import { useMemo } from 'react';

import { NumberPatternStrategy } from '@dreryk/react-common';
import { StyledFlex, StyledMaxWidth, TextInput } from '@dreryk/react-components';

import { prescriptionsHistoryDownloadTranslationKeys } from '../translations';

import { PatientDataAccessVerificationCodeFormController } from './PatientDataAccessVerificationCodeForm.types';

type PatientDataAccessVerificationCodeFieldProps = {
   readonly register: PatientDataAccessVerificationCodeFormController['register'];
};

const PATIENT_CODE_DIGITS = 4;

export const PatientDataAccessVerificationCodeField = (
   props: PatientDataAccessVerificationCodeFieldProps
): JSX.Element => {
   const validationRules = useMemo(
      () => ({
         maxLength: {
            value: PATIENT_CODE_DIGITS,
            message: prescriptionsHistoryDownloadTranslationKeys.max4Digits,
         },
         minLength: {
            value: PATIENT_CODE_DIGITS,
            message: prescriptionsHistoryDownloadTranslationKeys.min4Digits,
         },
         required: true,
      }),
      []
   );
   return (
      <StyledFlex flex={'1'}>
         <StyledMaxWidth maxWidth={70}>
            <TextInput
               label={prescriptionsHistoryDownloadTranslationKeys.patientCode}
               testId={'patientVerificationCode'}
               controller={props.register('code', validationRules)}
               pattern={NumberPatternStrategy.positiveInteger()}
               placeholder={prescriptionsHistoryDownloadTranslationKeys.patientCodePlaceholder}
               labelNoWrap
            />
         </StyledMaxWidth>
      </StyledFlex>
   );
};
